export const COMPANY_CONTACTS_FETCH_REQUESTED = 'COMPANY_CONTACTS_FETCH_REQUESTED'
export const COMPANY_CONTACTS_FETCH_SUCCESS = 'COMPANY_CONTACTS_FETCH_SUCCESS'
export const COMPANY_FETCH_REQUESTED = 'COMPANY_FETCH_REQUESTED'
export const COMPANY_FETCH_SUCCESS = 'COMPANY_FETCH_SUCCESS'
export const CONTACT_CREATE_REQUESTED = 'CONTACT_CREATE_REQUESTED'
export const CONTACT_CREATE_SUCCESS = 'CONTACT_CREATE_SUCCESS'
export const COMPANY_UPDATE_REQUESTED = 'COMPANY_UPDATE_REQUESTED'
export const COMPANY_UPDATE_SUCCESS = 'COMPANY_UPDATE_SUCCESS'
export const COMPANY_NOTES_FETCH_REQUESTED = 'COMPANY_NOTES_FETCH_REQUESTED'
export const COMPANY_NOTES_FETCH_SUCCESS = 'COMPANY_NOTES_FETCH_SUCCESS'
export const COMPANY_ADD_NOTE_REQUESTED = 'COMPANY_ADD_NOTE_REQUESTED'
export const COMPANY_ADD_NOTE_SUCCESS = 'COMPANY_ADD_NOTE_SUCCESS'
export const COMPANY_DELETE_NOTE_REQUESTED = 'COMPANY_DELETE_NOTE_REQUESTED'
export const COMPANY_DELETE_NOTE_SUCCESS = 'COMPANY_DELETE_NOTE_SUCCESS'
export const COMPANY_UPDATE_NOTE_REQUESTED = 'COMPANY_UPDATE_NOTE_REQUESTED'
export const COMPANY_UPDATE_NOTE_SUCCESS = 'COMPANY_UPDATE_NOTE_SUCCESS'

export const COMPANY_TASKS_FETCH_REQUESTED = 'COMPANY_TASKS_FETCH_REQUESTED'
export const COMPANY_TASKS_FETCH_SUCCESS = 'COMPANY_TASKS_FETCH_SUCCESS'
export const COMPANY_TASK_MARK_COMPLETED_REQUESTED = 'COMPANY_TASK_MARK_COMPLETED_REQUESTED'
export const COMPANY_TASK_MARK_COMPLETED_SUCCESS = 'COMPANY_TASK_MARK_COMPLETED_SUCCESS'
export const COMPANY_TASK_MARK_NOT_COMPLETED_REQUESTED = 'COMPANY_TASK_MARK_NOT_COMPLETED_REQUESTED'
export const COMPANY_TASK_MARK_NOT_COMPLETED_SUCCESS = 'COMPANY_TASK_MARK_NOT_COMPLETED_SUCCESS'
export const UPDATE_COMPANY_TASK_SUCCESS = 'UPDATE_COMPANY_TASK_SUCCESS'
export const UPDATE_COMPANY_TASK_REQUESTED = 'UPDATE_COMPANY_TASK_REQUESTED'
export const CREATE_COMPANY_TASK_REQUESTED = 'CREATE_COMPANY_TASK_REQUESTED'
export const CREATE_COMPANY_TASK_SUCCESS = 'CREATE_COMPANY_TASK_SUCCESS'
export const DELETE_COMPANY_TASK_REQUESTED = 'DELETE_COMPANY_TASK_REQUESTED'
export const DELETE_COMPANY_TASK_SUCCESS = 'DELETE_COMPANY_TASK_SUCCESS'
export const USERS_FETCH_REQUESTED = 'USERS_FETCH_REQUESTED'
